/**
 * MiniCourseCard Component
 * Card displaying minicourse information with link to MCG
 */

import React from "react";
import type { Language, MiniCourseLink } from "../types";
import { COURSE_TYPE_CONFIG, PILLAR_CONFIG } from "../types";

interface MiniCourseCardProps {
  course: MiniCourseLink;
  language: Language;
}

const MiniCourseCard: React.FC<MiniCourseCardProps> = ({ course, language }) => {
  const typeConfig = COURSE_TYPE_CONFIG[course.type];
  const pillarConfig = PILLAR_CONFIG[course.pillar];

  const labels = {
    cs: {
      minutes: "min",
      openCourse: "Otevřít kurz",
      free: "Zdarma",
    },
    en: {
      minutes: "min",
      openCourse: "Open course",
      free: "Free",
    },
  };

  const t = labels[language];

  return (
    <a
      href={course.url}
      target="_blank"
      rel="noopener noreferrer"
      className="minicourse-card"
    >
      {/* Title */}
      <h4 className="minicourse-title">{course.title}</h4>

      {/* Meta info */}
      <div className="minicourse-meta">
        <span className="minicourse-type-badge">
          {typeConfig.icon} {typeConfig.name[language]}
        </span>
        <span className="minicourse-meta-divider" />
        <span>⏱️ {course.durationMinutes} {t.minutes}</span>
        <span className="minicourse-meta-divider" />
        <span style={{ color: pillarConfig.color }}>
          {pillarConfig.icon} {course.pillar}
        </span>
        {course.isFree && (
          <>
            <span className="minicourse-meta-divider" />
            <span className="free-badge">{t.free}</span>
          </>
        )}
      </div>

      {/* Description */}
      {course.description && (
        <p style={{ fontSize: "13px", color: "var(--color-text-muted)", margin: "8px 0" }}>
          {course.description}
        </p>
      )}

      {/* CTA */}
      <span className="minicourse-cta">
        {t.openCourse} →
      </span>
    </a>
  );
};

export default MiniCourseCard;
